import { OnInit, Component, ViewChild } from "@angular/core";
import { MatTableDataSource, MatSort, MatDialog } from "@angular/material";
import { Router } from "@angular/router";
import { SearchCompleteFilterComponent } from "../../../../controls/search-complete-filter/search-complete-filter.component";
import { NotificationToastService } from "../../../../../services/notification-toast.service";
import { MenuService } from "../../../../../services/menu.service";
import { StudyReportDeliverySearchItem } from "../../../../../model/logistics/study-report";
import {
  SearchFilter,
  IFilterResponse,
} from "../../../../../infrastructure/iFilter-component";
import { PagerControlComponent } from "../../../../controls/pager/pager-control.component";
import { LogisticsService } from "../../../../../services/logistics.service";
import { ConfirmDialogService } from "../../../../../services/confirm-dialog.service";
// tslint:disable-next-line:max-line-length
import { StudyReportDeliveryObservationDialogComponent } from "../../../../dialogs/study-report-delivery-observation/study-report-delivery-observation-dialog.component";
import { AuthService } from "../../../../../services/auth.service";
import { PdfService } from "../../../../../services/pdf.service";
import { StudyReportService } from "../../../../../services/study-report/study-report.service";

@Component({
  selector: "app-study-report-delivery-search",
  templateUrl: "./study-report-delivery-search.component.html",
  styleUrls: ["./study-report-delivery-search.component.css"],
})
export class StudyReportDeliverySearchComponent implements OnInit {
  loading: boolean;
  loadingAction: boolean;
  searchFilters: SearchFilter[];
  widthTableExp: number;
  displayedColumns: string[] = [
    "Protocol",
    "PatientFullName",
    "PracticeName",
    "RegionName",
    "AdminControled",
    "Publicated",
    "StudyReportStateName",
    "StudyReportTransitStateName",
    "SectorName",
    "RecepcionDate",
    "star",
  ];
  dataSource = new MatTableDataSource([]);
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild("searchFilter", { static: false })
  searchFilter: SearchCompleteFilterComponent;
  @ViewChild("pager", { static: true }) pager: PagerControlComponent;

  constructor(
    private router: Router,
    private menuService: MenuService,
    private logisticsService: LogisticsService,
    private dialog: MatDialog,
    private authService: AuthService,
    private studyReportService: StudyReportService,
    private pdfService: PdfService,
    private confirmDialogService: ConfirmDialogService,
    private notificationToastService: NotificationToastService
  ) {
    this.menuService.setMenuTitle("Logística", "entrega de informes");
  }

  ngOnInit(): void {}

  onStartSearch(): void {
    this.loading = true;
  }

  selectedPageIndexChange(pagedItems: any[]) {
    this.dataSource = new MatTableDataSource(pagedItems);
    this.loading = false;
  }

  async print(studyReportDeliverySearchItem: StudyReportDeliverySearchItem) {
    try {
      this.loadingAction = true;
      const reportViewer = await this.studyReportService.getStudyReportPdf(
        studyReportDeliverySearchItem.StudyReportId
      );
      this.pdfService.base64ToPdfPrint(reportViewer.ReportBase64);
    } catch (err) {
      this.notificationToastService.error(
        JSON.stringify(err.error),
        "Revertir informe"
      );
    } finally {
      this.loadingAction = false;
    }
  }

  startDeliverty(studyReportDeliverySearchItem: StudyReportDeliverySearchItem) {
    if (studyReportDeliverySearchItem.DeliveryEnabled) {
      this.router.navigate([
        "study-report-delivery-wizard",
        studyReportDeliverySearchItem.StudyReportId,
      ]);
    } else {
      this.notificationToastService.error(
        "No es posible iniciar la entrega",
        "Entrega de informes"
      );
    }
  }

  async studyReportDeliveryForceReceiveAndStart(
    studyReportDeliverySearchItem: StudyReportDeliverySearchItem
  ) {
    if (!studyReportDeliverySearchItem.DeliveryEnabled) {
      this.notificationToastService.error(
        "No es posible realizar la entrega",
        "Entrega de informes"
      );
    } else {
      try {
        this.loadingAction = true;
        await this.logisticsService.studyReportDeliveryForceReceive(
          studyReportDeliverySearchItem.StudyReportId,
          this.authService.getSectorId()
        );
        this.router.navigate([
          "study-report-delivery-wizard",
          studyReportDeliverySearchItem.StudyReportId,
        ]);
      } catch (err) {
        this.notificationToastService.error(
          JSON.stringify(err.error),
          "Revertir informe"
        );
      } finally {
        this.loadingAction = false;
      }
    }
  }

  async rollbackDeliverty(
    studyReportDeliverySearchItem: StudyReportDeliverySearchItem
  ) {
    if (!studyReportDeliverySearchItem.DeliveryEnabled) {
      this.confirmDialogService
        .confirm(
          "Revertir informe",
          "Esta seguro que desea revertir el informe",
          "Aceptar",
          "Cancelar"
        )
        .subscribe(async (value) => {
          try {
            if (value) {
              this.loadingAction = true;
              await this.logisticsService.studyReportDeliveryRollBack(
                studyReportDeliverySearchItem.StudyReportId
              );
              await this.searchFilter.search();
            }
          } catch (err) {
            this.notificationToastService.error(
              JSON.stringify(err.error),
              "Revertir informe"
            );
          } finally {
            this.loadingAction = false;
          }
        });
    } else {
      this.notificationToastService.error(
        "El informe ya se encuentra revertido",
        "Entrega de informes"
      );
    }
  }

  async viewObservationDelivery(
    studyReportDeliverySearchItem: StudyReportDeliverySearchItem
  ) {
    if (!studyReportDeliverySearchItem.DeliveryEnabled) {
      const dialogRef = this.dialog.open(
        StudyReportDeliveryObservationDialogComponent,
        {
          width: "50%",
          data: studyReportDeliverySearchItem.StudyReportId,
        }
      );
    } else {
      this.notificationToastService.error(
        "El informe debe estar entregado",
        "Entrega de informes"
      );
    }
  }

  onEndSearch(response: IFilterResponse<StudyReportDeliverySearchItem>): void {
    this.searchFilters = response.searchFilters;
    this.pager.setItems(response.items);
  }
}
